import React from 'react';
import {ToastProvider} from "../utils/contexts/toast-context";
import {QueryClient, QueryClientProvider} from "react-query";
import {AccountingProvider} from "../utils/contexts/accounting_context";

type Props = {
    children: React.ReactNode;
}

const queryCLient = new QueryClient()
const MainProviders = ({children}: Props) => {
    return (
        <QueryClientProvider client={queryCLient}>
            <ToastProvider>
                <AccountingProvider>
                    {children}
                </AccountingProvider>
            </ToastProvider>
        </QueryClientProvider>
    );
};

export default MainProviders;